import Vue from 'vue'
import {getData} from '@/app/plugins/utils'
import { api as configs } from '../../../config'

export const getApiClient = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'costumer_api'+payload).then(getData)
}

export const postApiClient = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'costumer_api', payload).then(getData)
}

export const postGenerateTokenApiClient = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'costumer_api/'+payload.id+'/generate_token', payload.data).then(getData)
}

export const putApiClient = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'costumer_api/'+payload.id, payload).then(getData)
}

export const deleteApiClient = (payload = '') => {
  return Vue.http.delete(configs.baseUrl+'costumer_api'+payload).then(getData)
}

export const getLogista = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'logistics_group'+payload).then(getData)
}

export const getDocumentacao = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'documentacao'+payload).then(getData)
}

export const postLogista = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'logistics_group', payload).then(getData)
}

export const postAssociarLogista = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'logistics_group/'+payload.id+'/associate', payload).then(getData)
}

export const postSyncLogista = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'logistics_group/'+payload+'/sync', '').then(getData)
}

export const putLogista = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'logistics_group/'+payload.id, payload).then(getData)
}

export const getMCC = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'mcc'+payload).then(getData)
}

export const getProducts = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'product'+payload).then(getData)
}

export const getProduct = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'product'+payload).then(getData)
}

export const putProduct = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'product/'+payload.id, payload).then(getData)
}

export const putMCC = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'mcc/'+payload.id, payload).then(getData)
}

export const postProduct = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'product', payload).then(getData)
}

export const deleteProduct = (payload = '') => {
  return Vue.http.delete(configs.baseUrl+'product'+payload).then(getData)
}

export const postMCC = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'mcc', payload).then(getData)
}

export const deleteMCC = (payload = '') => {
  return Vue.http.delete(configs.baseUrl+'mcc'+payload).then(getData)
}

export const getBank = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'bank'+payload).then(getData)
}

export const getPaymentAdjustTypes = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'payment_adjust_type_api'+payload).then(getData)
}

export const putPaymentAdjustTypes = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'payment_adjust_type/'+payload.id, payload).then(getData)
}

export const postPaymentAdjustTypes = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'payment_adjust_type', payload).then(getData)
}

export const deletePaymentAdjustTypes = (payload = '') => {
  return Vue.http.delete(configs.baseUrl+'payment_adjust_type'+payload).then(getData)
}

export const putBank = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'bank/'+payload.id, payload).then(getData)
}

export const postBank = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'bank', payload).then(getData)
}

export const deleteBank = (payload = '') => {
  return Vue.http.delete(configs.baseUrl+'bank'+payload).then(getData)
}

export const getTypeBusiness = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'type_business'+payload).then(getData)
}

export const getPhoneOperator = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'phone_operator'+payload).then(getData)
}

export const putPhoneOperator = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'phone_operator/'+payload.id, payload).then(getData)
}

export const postPhoneOperator = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'phone_operator', payload).then(getData)
}

export const deletePhoneOperator = (payload = '') => {
  return Vue.http.delete(configs.baseUrl+'phone_operator'+payload).then(getData)
}

export const getCustosOpera = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'cost_plan'+payload).then(getData)
}

export const postCustosOpera = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'cost_plan', payload).then(getData)
}

export const putCustosOpera = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'cost_plan/'+payload.id, payload).then(getData)
}

export const deleteCustosOpera = (payload = '') => {
  return Vue.http.delete(configs.baseUrl+'cost_plan'+payload).then(getData)
}

export const getHoliday = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'holyday'+payload).then(getData)
}

export const putHoliday = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'holyday/'+payload.id, payload).then(getData)
}

export const postHoliday = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'holyday', payload).then(getData)
}

export const deleteHoliday = (payload = '') => {
  return Vue.http.delete(configs.baseUrl+'holyday'+payload).then(getData)
}

export const getProviders = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'provider'+payload).then(getData)
}

export const getAcquirers = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'acquirer'+payload).then(getData)
}

export const getModeloEquipamento = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'equipment_model'+payload).then(getData)
}

export const getMigration = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'migration_step/'+payload).then(getData)
}

export const getMarketplace = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'marketplace'+payload).then(getData)
}

export const getGerenteMarketplace = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'marketplace_manager'+payload).then(getData)
}

export const getDepartamentStore = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'department_store'+payload).then(getData)
}

export const getRepresentantes = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'agent'+payload).then(getData)
}

export const getCardBrand = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'card_brand'+payload).then(getData)
}

export const putCardBrand = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'card_brand/'+payload.id, payload).then(getData)
}

export const postCardBrand = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'card_brand', payload).then(getData)
}

export const postCalcularRav = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'card_brand/'+payload.id+'/rav', payload.data).then(getData)
}

export const deleteCardBrand = (payload = '') => {
  return Vue.http.delete(configs.baseUrl+'card_brand'+payload).then(getData)
}

export const getCity = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'cities'+payload).then(getData)
}

export const getState = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'states'+payload).then(getData)
}

export const getListMigracoes = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'migration_step/marketplace_missing'+payload).then(getData)
}

export const postMigracoes = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'migration_step', payload).then(getData)
}

export const postReprocessarLogMigracoes = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'migration_step_log/'+payload).then(getData)
}

export const postContinueMigracoes = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'migration_step/'+ payload).then(getData)
}

export const getLogsMigracao = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'migration_step_log'+payload).then(getData)
}

export const SearchMarketplaceMigrado = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'migration_step'+payload).then(getData)
}

export const getCountMarketplaceV1 = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'migration_step/marketplace_counter'+payload).then(getData)
}

// Pagamentos de markup em elatórios
export const getAllPaymentRate = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'payment_rate'+payload).then(getData)
}

export const getPaymentRate = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'payment_rate/'+payload).then(getData)
}

export const checkAcceptTerms = (payload = '') => {
  return Vue.http.get(configs.baseUrl+`acceptance_terms/${payload}/check`).then(getData)
}

export const getAcceptTerms = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'acceptance_terms'+payload).then(getData)
}

export const postAcceptTerms = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'acceptance_terms', payload).then(getData)
}

export const putAcceptTerms = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'acceptance_terms/'+payload.id, payload).then(getData)
}

export const deleteAcceptTerms = (payload = '') => {
  return Vue.http.delete(configs.baseUrl+'acceptance_terms/'+payload).then(getData)
}

export const sendAcceptTerms = (payload = '') => {
  return Vue.http.post(configs.baseUrl+`acceptance_terms/${payload}/accept`).then(getData)
}

export const getProfiles = (payload = '') => {
  return Vue.http.get(configs.baseUrl+`auth_profile${payload}`).then(getData)
}

export const getPermissions = (payload = '') => {
  return Vue.http.get(configs.baseUrl+`auth_profile/permissions${payload}`).then(getData)
}

export const postProfile = (payload = '') => {
  return Vue.http.post(configs.baseUrl+`auth_profile`, payload).then(getData)
}

export const putProfile = (id, payload = '') => {
  return Vue.http.put(configs.baseUrl+`auth_profile/${id}`, payload).then(getData)
}
